<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="19" height="3" viewBox="0 0 19 3" fill="none">
    <path d="M1.25 1.5L17.75 1.5" stroke="#D7541C" stroke-width="2" stroke-linecap="round"/>
    <path d="M1.25 1.5L17.75 1.5" stroke="#D7541C" stroke-width="2" stroke-linecap="round"/>
  </svg>
</template>

<style lang="scss" scoped>
</style>

<script>
export default {
  name: 'IconMinus'
}
</script>
